import React, { useEffect } from "react";
import { useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { useAuth } from "../components/msalAuth/AuthProvider";
import { IdleTimerProvider } from "../components/idle/IdleTimerProvider";
import Loader from "../components/configure/Loader";
import { isValidRedirectPath } from "../components/configure/utils";
import { Navigate } from "react-router-dom";

export default function PrivateRouteQR({ children }) {
  const { login, isAuthenticated } = useAuth();
  const { inProgress } = useMsal();
  const currentPath = window.location.pathname;
  const redirectPath = isValidRedirectPath(currentPath) ? currentPath : "/";
  sessionStorage.setItem("sd_redirect", redirectPath);

  useEffect(() => {
    if (!isAuthenticated) {
      const timer = setTimeout(() => {
        login();
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [isAuthenticated, login]);

  return (
    <>
      <AuthenticatedTemplate>
        {inProgress === "none" ? <IdleTimerProvider>{children}</IdleTimerProvider> : <Navigate to={redirectPath} replace />}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Loader message="Redirecting to login..." />
      </UnauthenticatedTemplate>
    </>
  );
}
